const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Atendiendo"
          },
          waiting: {
            title: "Pendientes"
          },
          closed: {
            title: "Resueltos"
          }
        },
      },
      connections: {
        title: "Conexiones",
        usage: {
          active: "Activa",
          inactive: "Inactiva",
        },
        toasts: {
          deleted:
            "La conexión ha sido borrada satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
          activateTitle: "Activar conexión",
          activateMessage:
            "Tu plan ya alcanzó el límite de conexiones activas, se desvinculará otra conexión para usar esta.",
        },
        buttons: {
          add: "Agregar conexión",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "Código QR",
          newQr: "Nuevo código QR",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          platform: "Plataforma",
          name: "Nombre",
          connection: "Conexión",
          status: "Estado",
          usage: "Uso",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      connectionModal: {
        title: {
          add: "Agregar conexión",
          edit: "Editar conexión",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
          timeZone: "Zona horaria",
          serverTimeZone: "Usar zona horaria del servidor",
          queueRedirectEnabled: "Redirección a Áreas",
          farewellMessage: "Mensaje de despedida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Conexión guardada satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los chats relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          connection: "Número",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          category: "Categoría",
          actionType: "Accion",
          sequence: "Secuencia",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      chatbotModal: {
        title: {
          add: "Agregar secuencia",
          edit: "Editar secuencia",
        },
        sections: {
          schedule: "Condición de horarios",
          chatbot: "Chatbot",
          quickReply: "Respuesta rápida",
          execution: "Pausa / Ejecuciones",
          transfer: "Transferir",
          labels: "Etiquetas",
          ai: "IA",
          blocks: "Mensajes",
        },
        form: {
          name: "Nombre",
          category: "Categoría",
          parent: "Secuencia padre",
          noParent: "Sin padre",
          matchType: "Tipo de coincidencia",
          requireAllTriggers: "Activar condiciones",
          trigger: "Disparadores",
          triggerHelp: "Usa un salto de linea por disparador.",
          conditionalTriggerHelp: "Usa una linea por condicion y comas para variaciones.",
          active: "Activa",
          quickReplyEnabled: "Activar respuesta rápida",
          quickReplyMatchType: "Tipo de coincidencia",
          quickReplyTrigger: "Disparadores de respuesta rápida",
          scheduleEnabled: "Activar restricción de ejecución por horarios",
          startTime: "Hora inicial",
          endTime: "Hora final",
          outOfHoursSequence: "Secuencia fuera de horario",
          noOutOfHoursSequence: "No ejecutar otra secuencia",
          executionMode: "Modo de ejecución",
          executionLimit: "Cantidad",
          executionInterval: "Tiempo",
          executionIntervalUnit: "Temporalidad",
          transferType: "Transferir",
          transferQueue: "Área",
          transferUser: "Usuario",
          noTransferAutoAssignQueues: "Sin área",
          noTransferAutoAssignUsers: "Sin usuario",
          transferAutoAssignRequired: "Selecciona al menos un área o usuario para activar el reparto.",
          addLabels: "Agregar etiquetas",
          removeLabels: "Quitar etiquetas",
          aiAction: "Accion de IA",
          chatbotAction: "Accion de Chatbot",
          aiInitialMessage: "Mensaje inicial simulado del cliente",
          aiPrompt: "Prompt personalizado",
          message: "Mensaje",
          delay: "Espera de",
          noFile: "Sin archivo",
          inactivityMessage: "Mensaje de inactividad",
          inactivityValue: "Tiempo",
          inactivityUnit: "Intervalo",
          inactivitySequence: "Secuencia a ejecutar",
          noInactivitySequence: "No ejecutar secuencia",
        },
        matchTypes: {
          exact: "Exacta",
          contains: "Contiene",
          conditional: "Condicional",
          anything: "Cualquier cosa",
          newChat: "Nuevo chat",
        },
        executionModes: {
          unlimited: "Sin limite",
          executionCount: "Por numero de ejecuciones",
          timeWindow: "Por tiempo transcurrido",
        },
        transferTypes: {
          none: "No transferir",
          queue: "Al área",
          user: "A usuario",
          both: "Al área y usuario",
          auto: "Autoasignacion",
          resolve: "Resolver",
        },
        aiActions: {
          none: "No cambiar IA",
          activate: "Activar IA",
          activateReset: "Activar IA y Resetear",
          deactivate: "Apagar IA",
          deactivateReset: "Apagar IA y Resetear",
        },
        chatbotActions: {
          none: "No cambiar",
          activate: "Activar",
          activateReset: "Activar y Resetear",
          deactivate: "Apagar",
          deactivateReset: "Apagar y Resetear",
        },
        units: {
          seconds: "Segundos",
          minutes: "Minutos",
          hours: "Horas",
          days: "Dias",
          months: "Meses",
        },
        actionTypes: {
          message: "Mensaje",
          sequence: "Secuencia",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          file: "Seleccionar archivo",
          removeFile: "Quitar",
          addBlock: "Agregar mensaje",
          addInactivityBlock: "Agregar mensaje de inactividad",
        },
        success: "Secuencia guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar área",
          edit: "Editar área",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
        },
        buttons: {
          okAdd: "Añadir",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Área guardada correctamente.",
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          connection: "Conexión estándar",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un chat para empezar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Áreas",
      },
      tickets: {
        toasts: {
          deleted: "El chat en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar chats y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
        chatFilters: {
          all: "Todos",
          groups: "Grupos",
          contacts: "Personas",
          unread: "No leidos",
        },
      },
      transferTicketModal: {
        title: "Transferir chat",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir al área",
        fieldConnectionLabel: "Transferir a conexión",
        fieldQueuePlaceholder: "Seleccione un área",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Pendientes",
        assignedHeader: "Atendiendo",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        agentTitle: "Agente que está atendiendo este chat.",
        noTicketsMessage:
          "No se encontraron chats con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
        },
      },
      newTicketModal: {
        title: "Crear chat",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Escritorio",
          connections: "Conexiones",
          tickets: "Chats",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          reminders: "Recordatorios",
          agenda: "Agenda",
          orders: "Pedidos",
          campaigns: "Campañas",
          internalChat: "Chat Interno",
          funnels: "Embudos",
          chatbot: "Chatbot",
          ai: "IA",
          queues: "Áreas",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
          superAdmin: "Superadministrador",
          accounts: "Cuentas",
          labels: "Etiquetas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Áreas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Comportamiento",
        },
        buttons: {
          add: "Agregar Área",
        },
        toasts: {
          deleted: "Área eliminada correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los chats en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Áreas",
      },
      ticketLabels: {
        inputLabel: "Etiquetas",
        placeholder: "Agregar etiquetas",
        filterLabel: "Etiquetas",
      },
      labels: {
        title: "Etiquetas",
        table: {
          name: "Nombre",
          color: "Color",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar etiqueta",
        },
        toasts: {
          deleted: "Etiqueta eliminada correctamente",
        },
        confirmationModal: {
          deleteTitle: "Eliminar etiqueta",
          deleteMessage: "Esta accion no se puede deshacer.",
        },
      },
      labelModal: {
        title: {
          add: "Agregar etiqueta",
          edit: "Editar etiqueta",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada correctamente.",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          category: "Categoría",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      agendaPage: {
        title: "Agenda",
      },
      remindersPage: {
        title: "Recordatorios",
        form: {
          contact: "Contacto",
        },
        table: {
          contact: "Contacto",
          connection: "Conexión",
          date: "Fecha y hora",
          status: "Estado",
          message: "Mensaje",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar recordatorio",
        },
        validation: {
          contact: "Selecciona un contacto.",
        },
        empty: "No hay recordatorios programados.",
      },
      internalChat: {
        title: "Chat Interno",
        empty: "Crea o selecciona un chat interno para empezar.",
        inputPlaceholder: "Escribe un mensaje",
        buttons: {
          new: "Nuevo",
          cancel: "Cancelar",
          create: "Crear",
          save: "Guardar",
        },
        create: {
          title: "Crear chat interno",
          name: "Nombre del Chat Interno",
          users: "Usuarios",
        },
        edit: {
          title: "Editar chat interno",
        },
      },
      chatbot: {
        title: "Chatbot",
        table: {
          name: "Secuencia",
          category: "Categoría",
          parent: "Padre",
          matchType: "Coincidencia",
          blocks: "Mensajes",
          status: "Estado",
          actions: "Acciones",
        },
        status: {
          active: "Activa",
          inactive: "Inactiva",
        },
        buttons: {
          add: "Agregar secuencia",
        },
        toasts: {
          deleted: "Secuencia eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle: "¿Eliminar esta secuencia?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      ai: {
        title: "IA",
        form: {
          active: "Activar IA",
          apiKey: "API Key de OpenAI",
          model: "Modelo de IA",
          skipMarkAsRead: "No marcar como leido al responder",
          waitModeEnabled: "Modo espera",
          waitModeSeconds: "Tiempo de espera en segundos",
          applyConversationContext: "Aplicar contexto de la conversación",
          conversationContextMessages: "Mensajes de contexto",
          prompt: "Prompt",
        },
        buttons: {
          save: "Guardar",
        },
        toasts: {
          saved: "Configuracion de IA guardada correctamente.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          connection: "Conexión estándar",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los chats abiertos de los usuarios se moverán a la cola.",
        },
      },
      superAdmin: {
        title: "Cuentas SaaS",
        sections: {
          users: "Usuarios",
          connections: "Conexiones",
        },
        table: {
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          status: "Estado",
          connection: "Conexión",
          default: "Por defecto",
          actions: "Acciones",
        },
        form: {
          expiresAt: "Fecha de expiracion",
          maxUsers: "Limite de usuarios",
          maxConnections: "Limite de conexiones",
        },
        buttons: {
          refresh: "Actualizar",
          enter: "Ingresar",
          saveExpiration: "Guardar expiracion",
          clearExpiration: "Sin expiracion",
          saveSettings: "Guardar limites",
          clearLimits: "Sin limites",
          delete: "Eliminar",
          reset: "Limpiar cuenta",
        },
        values: {
          yes: "Si",
          no: "No",
          active: "Activa",
          expired: "Expirada",
        },
        toasts: {
          expirationSaved: "Fecha de expiracion guardada.",
          settingsSaved: "Configuracion de cuenta guardada.",
          deleted: "Cuenta eliminada correctamente.",
          reset: "Cuenta limpiada correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar cuenta",
          deleteMessage:
            "Esta accion eliminara la cuenta SaaS y todos sus usuarios, conexiones, contactos, chats y configuraciones. Esta accion no se puede deshacer.",
          resetTitle: "Limpiar cuenta",
          resetMessage:
            "Esta accion borrara usuarios secundarios, conexiones, contactos, chats, automatizaciones y configuraciones de esta cuenta. Solo se conservara el usuario admin principal. Esta accion no se puede deshacer.",
        },
        empty: {
          accounts: "No hay cuentas registradas.",
          connections: "Esta cuenta no tiene conexiones.",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          dashboardWebChatScript: {
            name: "Script de WebChat en dashboard",
            helper:
              "Pega el snippet del WebChat. Se cargará para usuarios logueados y usará su nombre y correo.",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escribe un mensaje",
        placeholderClosed:
          "Vuelva a abrir o acepte este chat para enviar un mensaje.",
        signMessage: "Firmar",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        whatsapp: {
          invalid:
            "Este numero no tiene WhatsApp. Puedes conservarlo como dato del cliente, pero no se podran enviar mensajes de WhatsApp a este numero.",
          pending:
            "Este numero aun no fue verificado en WhatsApp. Puedes conservarlo como dato del cliente; al intentar enviar se verificara nuevamente.",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        clearChat: "Vaciar chat",
        clearChatSuccess: "Chat vaciado correctamente.",
        clearChatMediaCleanupWarning:
          "El chat se vació, pero no se pudieron eliminar {{count}} archivos adjuntos. Revisa los registros del servidor.",
        delete: "Borrar",
        transfer: "Transferir",
        ai: "IA",
        chatbot: "Chatbot",
        reminders: "Recordatorios",
        notes: "Notas",
        syncMessages: "Sincronizar mensajes",
        syncSuccess: "{{count}} mensaje(s) sincronizado(s).",
        syncSettingsSaved: "Configuracion de sincronizacion guardada.",
        syncModal: {
          title: "Sincronizar mensajes",
          autoSyncLabel: "Sincronizar automaticamente al crear el chat",
          description:
            "Cuando esta activo, al recibirse un mensaje que crea un chat nuevo se intentan cargar automaticamente los mensajes previos. Si lo desactivas, puedes sincronizar manualmente desde aqui.",
          syncNow: "Sincronizar ahora",
          save: "Guardar",
        },
        confirmationModal: {
          title: "¿Borrar chat #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes relacionados con el chat se perderán.",
        },
        clearChatConfirmationModal: {
          title: "Vaciar chat #",
          titleFrom: "del contacto ",
          message:
            "Atencion! Se borraran todos los mensajes de este chat, pero el chat se conservara.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      ticketAiModal: {
        title: "IA del chat",
        status: {
          active: "La IA esta activa en este chat.",
          inactive: "La IA esta apagada en este chat.",
        },
        buttons: {
          activate: "Activar IA",
          deactivate: "Apagar IA",
          deactivateReset: "Apagar y Resetear",
          close: "Cerrar",
        },
        toasts: {
          activate: "IA activada en este chat.",
          deactivate: "IA apagada en este chat.",
          deactivateReset: "IA apagada y reseteada en este chat.",
        },
        confirmationModal: {
          title: "Apagar y resetear IA",
          message:
            "¿Estas seguro? Se eliminara el hilo de conversacion de IA de este chat.",
        },
      },
      ticketChatbotModal: {
        title: "Chatbot del chat",
        status: {
          active: "El chatbot esta activo en este chat.",
          inactive: "El chatbot esta apagado en este chat.",
        },
        buttons: {
          activate: "Activar Chatbot",
          activateReset: "Activar y Resetear Chatbot",
          deactivate: "Apagar Chatbot",
          deactivateReset: "Apagar y Resetear Chatbot",
          close: "Cerrar",
        },
        toasts: {
          activate: "Chatbot activado en este chat.",
          activateReset: "Chatbot activado y reseteado en este chat.",
          deactivate: "Chatbot apagado en este chat.",
          deactivateReset: "Chatbot apagado y reseteado en este chat.",
        },
        confirmationModal: {
          activateReset: {
            title: "Activar y resetear chatbot",
            message:
              "Se limpiara la jerarquia actual, las ejecuciones y las pausas pendientes antes de activar el chatbot.",
          },
          deactivateReset: {
            title: "Apagar y resetear chatbot",
            message:
              "Se limpiara la jerarquia actual, las ejecuciones y las pausas pendientes, y el chatbot quedara apagado.",
          },
        },
      },
      ticketNotesModal: {
        title: "Notas",
        empty: "Este chat no tiene notas internas.",
        buttons: {
          close: "Cerrar",
        },
      },
      ticketRemindersModal: {
        title: "Recordatorios",
        empty: "Este contacto no tiene recordatorios.",
        form: {
          title: "Titulo",
          actionType: "Accion",
          date: "Fecha",
          time: "Hora",
          recurrenceValue: "Repetir cada",
          recurrenceUnit: "Unidad",
          sequence: "Secuencia",
          message: "Mensaje",
          delay: "Espera de",
          noFile: "Sin archivo",
        },
        actionTypes: {
          message: "Mensaje",
          sequence: "Secuencia",
        },
        recurrenceUnits: {
          none: "Sin recurrencia",
          seconds: "Segundos",
          minutes: "Minutos",
          hours: "Horas",
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
        },
        status: {
          pending: "Pendiente",
          processing: "Procesando",
          completed: "Completado",
          failed: "Fallido",
          cancelled: "Cancelado",
        },
        values: {
          untitled: "Recordatorio sin titulo",
          completed: "Completado",
        },
        buttons: {
          add: "Nuevo recordatorio",
          save: "Guardar",
          cancel: "Cancelar",
          close: "Cerrar",
          file: "Seleccionar archivo",
          removeFile: "Quitar",
          addBlock: "Agregar mensaje",
        },
        toasts: {
          saved: "Recordatorio guardado correctamente.",
          deleted: "Recordatorio eliminado correctamente.",
        },
        validation: {
          datetime: "Selecciona fecha y hora.",
          recurrence: "Indica cada cuanto se repetira.",
          sequence: "Selecciona una secuencia.",
          message: "Agrega al menos un mensaje o archivo.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar recordatorio",
          deleteMessage: "Esta accion no se puede deshacer.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_SENDING_CHANNEL_MSG:
          "Error al enviar el mensaje por el canal. Verifique la conexión y vuelva a autorizar si es necesario.",
        ERR_TICKET_NO_CHANNEL:
          "El ticket no tiene una conexión asociada.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un chat abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_COMPANY_EXPIRED:
          "Esta cuenta ha expirado. Contacta al administrador.",
        ERR_NO_COMPANY_FOUND: "No se encontro ninguna cuenta con este ID.",
        ERR_INVALID_LIMIT: "El limite debe ser un numero entero mayor o igual a cero.",
        ERR_INVALID_AI_CREDIT_LIMIT:
          "El limite de creditos IA debe ser un numero mayor o igual a cero.",
        ERR_INVALID_AI_CREDIT_USAGE:
          "El consumo de creditos IA debe ser un numero mayor o igual a cero.",
        ERR_AI_INCLUDED_CREDITS_EXCEEDED:
          "La cuenta alcanzo el limite de creditos de IA incluida.",
        ERR_COMPANY_USERS_LIMIT_REACHED:
          "Esta cuenta alcanzo el limite de usuarios.",
        ERR_COMPANY_WHATSAPPS_LIMIT_REACHED:
          "Esta cuenta alcanzo el limite de conexiones.",
        ERR_COMPANY_WHATSAPP_SESSIONS_LIMIT_REACHED:
          "Tu plan alcanzo el limite de conexiones activas. Para usar esta conexion, desconecta una conexion activa o contrata una conexion adicional.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún chat con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el chat en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_CAMPAIGN_CONNECTION_REQUIRED:
          "Selecciona una conexion para la campaña.",
        ERR_CAMPAIGN_NAME_REQUIRED: "Escribe el nombre de la campaña.",
        ERR_INVALID_CAMPAIGN_ACTION: "La accion de la campaña no es valida.",
        ERR_CAMPAIGN_EMPTY_MESSAGE: "Agrega al menos un mensaje o archivo.",
        ERR_CAMPAIGN_SEQUENCE_REQUIRED: "Selecciona una secuencia.",
        ERR_CAMPAIGN_LABEL_REQUIRED: "Selecciona al menos una etiqueta.",
        ERR_CAMPAIGN_STAGE_REQUIRED: "Selecciona embudo y etapa.",
        ERR_CAMPAIGN_LIST_REQUIRED: "Selecciona una lista guardada.",
        ERR_CAMPAIGN_LIST_EMPTY: "Selecciona al menos un ticket para guardar la lista.",
        ERR_CAMPAIGN_EMPTY_AUDIENCE: "Selecciona al menos un ticket.",
        ERR_NO_CAMPAIGN_FOUND: "No se encontro la campaña.",
        ERR_CAMPAIGN_RUNNING_LOCKED:
          "No puedes editar una campaña en ejecucion.",
      },
    },
  },
};

export { messages };

